import React, { useEffect, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import BdDashboardinner from "./BdDashboardinner";
const BdCountDashboard = () => {
  return (
    <>
      <Dashboardnavbar name="Bd Dashbaord" url="BdDashboard" />

      <div className="content-tabs">
        <div>
          <BdDashboardinner />

          <ToastContainer position="top-center" autoClose={1000} />
        </div>
      </div>
    </>
  );
};

export default BdCountDashboard;
